document.addEventListener("DOMContentLoaded", function () {
  const slides = document.querySelector(".slides");
  const slideElements = document.querySelectorAll(".slide");
  const activeSlideElements = document.querySelectorAll(
    ".slide.active-variant"
  );
  let thumbnails = document.querySelectorAll(".thumbnail");
  let activeThumbnails = document.querySelectorAll(".thumbnail.active-variant");
  const prevBtn = document.querySelector(".prev");
  const nextBtn = document.querySelector(".next");
  let currentIndex = 0;
  let totalSlides = thumbnails.length;
  let totalActiveSlides = activeThumbnails.length;
  let slideWidth = 20;

  if (totalActiveSlides > 5) {
    slides.style.width = `${totalActiveSlides * 100}%`;
  }

  // Modal elements
  const modal = document.getElementById("productSliderModal");
  const modalImg = document.getElementById("productSliderImage");
  const closeModal = document.getElementById("productSliderCloseModal");

  function updateTotalSlides() {
    activeThumbnails = document.querySelectorAll(".thumbnail.active-variant");
    totalActiveSlides = activeThumbnails.length;
    slideWidth = 100 / totalActiveSlides;
    updateSliderScroll();
    return activeThumbnails.length;
  }

  function updateSliderScroll() {
    slideWidth = totalActiveSlides > 5 ? 100 / totalActiveSlides : 20;
    slides.style.width =
      totalActiveSlides > 5 ? `${totalActiveSlides * 100}%` : "500%";
    //console.log(`${totalActiveSlides * 100}%`);
  }

  // Function to update the slider position
  function updateSlider() {
    slides.style.transform = `translateX(-${currentIndex * slideWidth}%)`;

    // Update active thumbnail
    activeThumbnails.forEach((thumb, index) => {
      if (index === currentIndex) {
        thumb.classList.add("active");
      } else {
        thumb.classList.remove("active");
      }
    });
  }

  function updateSliderThumbnail() {
    let activeThumbnails = document.querySelectorAll(
      ".thumbnail.active-variant"
    );
    let dataIndexes = [];

    activeThumbnails.forEach((thumbnail) => {
      let dataIndex = thumbnail.getAttribute("data-index");
      if (dataIndex !== null) {
        dataIndexes.push(parseInt(dataIndex));
      }
    });

    let newCurrentIndex = dataIndexes.indexOf(currentIndex);
    slides.style.transform = `translateX(-${newCurrentIndex * slideWidth}%)`;

    // Update active thumbnail
    activeThumbnails.forEach((thumb, index) => {
      if (index === newCurrentIndex) {
        thumb.classList.add("active");
      } else {
        thumb.classList.remove("active");
      }
    });
  }

  // Event listeners for thumbnails
  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener("click", () => {
      currentIndex = index;
      updateSliderThumbnail();
    });
  });

  // Event listeners for arrows
  prevBtn.addEventListener("click", () => {
    totalSlides = updateTotalSlides();
    currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
    updateSlider();
  });

  nextBtn.addEventListener("click", () => {
    totalSlides = updateTotalSlides();
    currentIndex = (currentIndex + 1) % totalSlides;
    updateSlider();
  });

  // Initialize slider
  updateSlider();

  $(".js-get-variant").on("click", function (event) {
    updateTotalSlides();
  });

  // Zoom functionality

  slideElements.forEach((slide) => {
    const img = slide.querySelector("img");
    const zoomLens = slide.querySelector(".zoom-lens");
    const zoomResult = slide.querySelector(".zoom-result");
    const zoomFactor = 0.3;
    let zoomActive = false;

    // Function to get cursor position
    function getCursorPos(e) {
      let x = 0,
        y = 0;
      e = e || window.event;
      const rect = img.getBoundingClientRect();
      x = e.pageX - rect.left - window.pageXOffset;
      y = e.pageY - rect.top - window.pageYOffset;
      return { x, y };
    }

    // Function to move zoom lens
    function moveLens(e) {
      if (!zoomActive) return;

      //e.preventDefault();
      const pos = getCursorPos(e);
      let x = pos.x - zoomLens.offsetWidth / 2;
      let y = pos.y - zoomLens.offsetHeight / 2;

      // Prevent lens from going outside the image
      if (x > img.width - zoomLens.offsetWidth) {
        x = img.width - zoomLens.offsetWidth;
      }
      if (x < 0) {
        x = 0;
      }
      if (y > img.height - zoomLens.offsetHeight) {
        y = img.height - zoomLens.offsetHeight;
      }
      if (y < 0) {
        y = 0;
      }

      // Set lens position
      zoomLens.style.left = x + "px";
      zoomLens.style.top = y + "px";

      // Calculate ratio between zoomResult and lens with zoom factor
      const cx = (zoomResult.offsetWidth / zoomLens.offsetWidth) * zoomFactor;
      const cy = (zoomResult.offsetHeight / zoomLens.offsetHeight) * zoomFactor;
      const Xpos = (x * cx) / 2;
      const Ypos = (y * cy) / 1.5;

      // Set background properties for the zoom result
      zoomResult.style.backgroundImage = `url('${img.src}')`;
      zoomResult.style.backgroundSize = `${img.width * cx}px ${
        img.height * cy
      }px`;
      zoomResult.style.backgroundPosition = `-${Xpos}px -${Ypos}px`;
    }

    // Event listeners for zoom

    // Open modal
    img.addEventListener("click", function () {
      if (window.innerWidth < 768) {
        modal.style.display = "block";
        modalImg.src = this.src;
      } else {
        zoomActive = !zoomActive;

        if (zoomActive) {
          slide.classList.add("zoom-active");
          zoomLens.style.display = "block";
          zoomResult.style.opacity = "1";
          moveLens(e); // Initialize lens position at click location
        } else {
          slide.classList.remove("zoom-active");
          zoomLens.style.display = "none";
          zoomResult.style.opacity = "0";
        }
      }
    });

    // Move lens when mouse moves
    img.addEventListener("mousemove", function (e) {
      moveLens(e);
    });

    // Deactivate zoom when changing slides
    thumbnails.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        zoomActive = false;
        slide.classList.remove("zoom-active");
        zoomLens.style.display = "none";
        zoomResult.style.opacity = "0";
      });
    });

    // Deactivate zoom when using arrow navigation
    prevBtn.addEventListener("click", () => {
      zoomActive = false;
      slide.classList.remove("zoom-active");
      zoomLens.style.display = "none";
      zoomResult.style.opacity = "0";
    });

    nextBtn.addEventListener("click", () => {
      zoomActive = false;
      slide.classList.remove("zoom-active");
      zoomLens.style.display = "none";
      zoomResult.style.opacity = "0";
    });
  });

  // Close modal when clicking the close button
  closeModal.addEventListener("click", function () {
    modal.style.display = "none";
  });

  // Close modal when clicking outside the image
  modal.addEventListener("click", function (e) {
    if (e.target === modal) {
      modal.style.display = "none";
    }
  });
});
